export const rangeslider = () => {};
